module.exports = __webpack_public_path__ + "static/media/home3.ded3d1cd.webp";